export interface IReferrer {
  invitationLink: string;
  email: string;
  phoneNumber?: string;
  firstName?: string;
  lastName?: string;
  birthDate?: string;
  address?: string;
  status: EReferrerStatus;
  iban?: string;
  taxCode?: string;
}

export enum EReferrerStatus {
  Active = 'active',
  Deleted = 'deleted',
}
